/** Empty value: long dash*/
export const emptyValue = '\u2014';

export const IT_HUB_ORIGIN = 'IT_HUB';
export const IT_HUB_EMBEDDED_ORIGIN = 'IT_HUB_EMBEDDED';

export const SUPPORT_EMAIL = 'support@electric.ai';

export const ISO_DATE_FORMAT = 'yyyy-MM-dd';
